import { render, staticRenderFns } from "./_infoMl.vue?vue&type=template&id=f88ee598"
import script from "./_infoMl.vue?vue&type=script&lang=js"
export * from "./_infoMl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports